import { useMemo } from 'react';

import useGet from 'lib/hooks/useGet';
import { UPB_VIEWER_BETA_CHILD_CATEGORY_STATS } from 'lib/networking/endpoints';

/**
 * useUPBBetaChildCategoryStats — per-child-category stats for the Beta
 * category drill-down cards (annualized GMV, active SKUs, DP count).
 *
 * Pass the deepest parent in the URL. With no params, groups at L1.
 *
 * Returns { data, loading, error, refetch }
 *   data shape: { data: [ { child_id, annualized_gmv, total_skus,
 *                           active_skus, dp_count }, ... ] }
 */
function useUPBBetaChildCategoryStats({
  l1CategoryId,
  l2CategoryId,
  l3CategoryId,
  vendorId,
  thirdPartyTag,
  skip = false,
} = {}) {
  const params = useMemo(() => {
    const p = {};
    if (l1CategoryId) p.l1_category_id = l1CategoryId;
    if (l2CategoryId) p.l2_category_id = l2CategoryId;
    if (l3CategoryId) p.l3_category_id = l3CategoryId;
    if (vendorId) p.vendor_id = vendorId;
    if (thirdPartyTag) p.third_party_tag = thirdPartyTag;
    return p;
  }, [l1CategoryId, l2CategoryId, l3CategoryId, vendorId, thirdPartyTag]);

  return useGet(UPB_VIEWER_BETA_CHILD_CATEGORY_STATS, params, skip);
}

export default useUPBBetaChildCategoryStats;
